import React from 'react';
import { Deck, Slayt, Metrik, MetrikSira, Tablo, Not, Dagilim, GrupSeridi, tl } from './EylulSlaytKit';

/**
 * HUPALUPA Store — Eylül 2026 medya planı. ÜÇ slayt.
 *
 * 🔑 Bütçe müşteriden GELMEDİ, biz öneriyoruz: Ağustos ₺449.392 → ₺495.000 (+%10,1).
 * 🔑 Bu markada Eylül bir "daha çok harca" ayı DEĞİL, bir KARMA DEĞİŞTİRME ayı:
 *    oyuncak talebi düşerken kırtasiye talebi zirveye çıkıyor. Artışın tamamı
 *    1-15 Eylül kırtasiye penceresine kilitli, ikinci yarı Ağustos temposuna döner.
 *
 * Sayıların kaynağı: arama hacimleri Keyword Planner (geo TR 2792, dil 1000,
 * GOOGLE_SEARCH, çekim 31 Ağu 2026); harcama/ciro /api/group/hupalupa/monthly
 * (canlı Meta + Google Ads + GA4 property 364875770).
 * ⚠️ Ağustos rakamları 31 Ağu 14:29 (TR) itibarıyla; ayın son yarım günü eksik.
 * ⚠️ Ciro mecraların/GA4'ün beyanı — seviye değil eğilim okuyun.
 */

export default function HupalupaStoreEylul2026() {
  return (
    <Deck
      marka="HUPALUPA Store"
      altBaslik="Oyuncak + kırtasiye e-ticaret · hupalupa.store · Meta + Google Ads"
      logo="/logos/grup/hupalupa-store.svg"
      logoBg="bg-white border border-gray-200"
      butce={495000}
      oncekiButce={449392}
    >
      {/* ════════════ SLAYT 1 — TALEP ════════════ */}
      <Slayt
        no={1}
        etiket="Slayt 1 · Talep"
        accent="#0F766E"
        baslik="Eylül'de talep oyuncaktan kırtasiyeye kayıyor. Bütçe de kaymalı."
        spot="Katalogun iki yarısı Eylül'de zıt yönlere gidiyor: oyuncak sorguları geriliyor, kırtasiye sorguları yılın zirvesine çıkıyor. İki yıl üst üste aynı desen. Doğru hamle bütçeyi topluca büyütmek değil, artışı okulun açıldığı ilk iki haftaya kilitlemek."
        dipnot="Kaynak: Google Ads Keyword Planner, geo Türkiye, dil Türkçe, yalnızca Google Arama. Uyarı: Planner değerleri sabit bucket'lardan gelir (…40.500, 49.500, 60.500…), o yüzden pek çok satırda değişim tam +%22 / −%18 çıkar; bu iki komşu bucket arasındaki adımdır, ölçüm hatası değil."
      >
        <MetrikSira kolon={4}>
          <Metrik etiket="&quot;kırtasiye&quot; Eylül 2025" deger="673.000" alt="Ağustos 550.000 → +%22" ton="iyi" />
          <Metrik etiket="&quot;beslenme çantası&quot; Eylül" deger="+%83" alt="40.500 → 74.000 · 2024'te +%82" ton="iyi" />
          <Metrik etiket="&quot;oyuncak&quot; Eylül" deger="−%18" alt="110.000 → 90.500" ton="kotu" />
          <Metrik etiket="Feed'de hazır kırtasiye ürünü" deger="786" alt="27 Ağu'da okula-dönüş çerçevesiyle canlı" ton="iyi" />
        </MetrikSira>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
          <Tablo
            baslik="Eylül'de YÜKSELEN talep"
            basliklar={['Kelime', 'Ağu 2025', 'Eyl 2025', 'Değişim']}
            saga={[1, 2, 3]}
            satirlar={[
              [{ v: 'kırtasiye', kalin: true }, '550.000', '673.000', { v: '+%22', ton: 'iyi', kalin: true }],
              [{ v: 'beslenme çantası', kalin: true }, '40.500', '74.000', { v: '+%83', ton: 'iyi', kalin: true }],
              ['puzzle', '27.100', '33.100', { v: '+%22', ton: 'iyi' }],
              ['peluş oyuncak', '40.500', '40.500', { v: '%0', ton: 'soluk' }],
            ]}
          />
          <Tablo
            baslik="Eylül'de DÜŞEN talep"
            basliklar={['Kelime', 'Ağu 2025', 'Eyl 2025', 'Değişim']}
            saga={[1, 2, 3]}
            satirlar={[
              [{ v: 'okul çantası', kalin: true }, '246.000', '135.000', { v: '−%45', ton: 'kotu', kalin: true }],
              ['kırtasiye malzemeleri', '27.100', '18.100', { v: '−%33', ton: 'kotu' }],
              ['lego', '301.000', '246.000', { v: '−%18', ton: 'kotu' }],
              [{ v: 'oyuncak', kalin: true }, '110.000', '90.500', { v: '−%18', ton: 'kotu' }],
            ]}
          />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
          <Not tip="iyi" baslik="Kırtasiyenin zirvesi Ağustos değil, Eylül">
            Sezon iletişiminde en sık yapılan hata çantayı ve kırtasiyeyi aynı takvime koymak.
            <strong> Okul çantası Ağustos'ta zirve yapıp Eylül'de %45 düşüyor</strong> — alışverişi okul açılmadan
            yapılıyor. <strong>Kırtasiyenin ve beslenme çantasının zirvesi ise Eylül</strong>: liste okuldan
            gelince alınıyor, beslenme çantası ilk hafta unutulanların başında. İki desen de 2024 ve 2025'te birebir aynı.
          </Not>
          <Not tip="uyari" baslik="Uzun vadede kategori küçülüyor — bunu görmezden gelmeyelim">
            Yıldan yıla bakıldığında "kırtasiye" Ağustos hacmi 2024'te 823.000, 2025'te 550.000
            (<strong>−%33 YoY</strong>). Eylül sıçraması her yıl var, ama zemin alçalıyor. Bu, artışın neden
            <strong> kalıcı bütçe değil, iki haftalık pencere</strong> olarak istendiğinin de gerekçesi.
          </Not>
        </div>
      </Slayt>

      {/* ════════════ SLAYT 2 — KANIT ════════════ */}
      <Slayt
        no={2}
        etiket="Slayt 2 · Kanıt"
        accent="#B45309"
        baslik="Bu hesapta daha fazla harcamak son iki ayda daha az ciro getirdi."
        spot="Temmuz'da ₺376 bin harcandı, ₺1,48 milyon ciro geldi. Ağustos'ta %19 daha fazla harcandı, ciro %8 düştü. Marjinal verim düşüyor — bu yüzden Eylül talebimiz %10'la sınırlı ve tamamı zamana kilitli."
        dipnot="Kaynak: canlı Meta Ads API (act_1469447184541059), Google Ads (4331901678), GA4 property 364875770 üzerinden /api/group/hupalupa/monthly. Uyarı: ciro mecra ve GA4 beyanıdır; Google ile Meta aynı satışı ikisi de kendine yazabilir. Seviye değil eğilim okuyun."
      >
        <MetrikSira kolon={4}>
          <Metrik etiket="Temmuz harcama → ciro" deger="3,94×" alt="₺376.293 → ₺1.483.029" ton="iyi" />
          <Metrik etiket="Ağustos harcama → ciro" deger="3,04×" alt="₺449.392 → ₺1.367.139" ton="kotu" />
          <Metrik etiket="Harcama farkı" deger="+%19" alt="Temmuz'a göre Ağustos" />
          <Metrik etiket="Ciro farkı" deger="−%8" alt="aynı dönemde" ton="kotu" />
        </MetrikSira>

        <Tablo
          baslik="HUPALUPA Store — son 6 ay gerçekleşen"
          basliklar={['Ay', 'Meta', 'Google', 'Toplam harcama', 'Ciro', 'Harcama → ciro']}
          saga={[1, 2, 3, 4, 5]}
          satirlar={[
            ['Mart 2026', '₺296.639', '₺234.484', '₺531.123', '₺1.055.488', { v: '1,99×', ton: 'kotu' }],
            ['Nisan 2026', '₺222.840', '₺222.524', '₺445.364', '₺1.354.426', '3,04×'],
            ['Mayıs 2026', '₺257.456', '₺215.067', '₺472.523', '₺1.570.982', '3,32×'],
            ['Haziran 2026', '₺297.200', '₺223.011', '₺520.211', '₺1.698.036', '3,26×'],
            [{ v: 'Temmuz 2026', kalin: true }, '₺214.594', '₺161.699', { v: '₺376.293', kalin: true }, '₺1.483.029', { v: '3,94×', ton: 'iyi', kalin: true }],
            [{ v: 'Ağustos 2026', kalin: true }, '₺269.121', '₺180.271', { v: '₺449.392', kalin: true }, '₺1.367.139', { v: '3,04×', ton: 'kotu', kalin: true }],
          ]}
        />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
          <Not tip="uyari" baslik="Neden yine de artış istiyoruz">
            Marjinal verim düşüyorsa doğru refleks bütçeyi kısmaktır. Eylül'de bir istisna var:
            <strong> talebin kendisi artıyor</strong>. Ağustos'ta ek para aynı havuzdan daha pahalı trafik
            almak zorundaydı; 1-15 Eylül'de <strong>havuzun kendisi büyüyor</strong> (kırtasiye +%22,
            beslenme çantası +%83). Ek bütçenin daha ucuz trafiğe gitmesinin tek koşulu <strong>doğru
            iki hafta</strong> — o yüzden artış tarihe kilitli.
          </Not>
          <Not tip="iyi" baslik="Envanter ve kreatif hazır, gecikme riski yok">
            27 Ağustos'ta <strong>786 kırtasiye ürünü</strong> okula-dönüş çerçevesiyle canlı feed'e bağlandı
            (29 alt kategori; en büyükleri Çanta &amp; Kalem Kutuları 174, Eğitici Aktivite Setleri 136,
            Suluklar &amp; Termoslar 61 — 88'i indirimli). Yani bütçe onaylandığı gün yayına girebilir;
            kreatif veya feed beklemiyoruz.
          </Not>
        </div>
      </Slayt>

      {/* ════════════ SLAYT 3 — TALEP ════════════ */}
      <Slayt
        no={3}
        etiket="Slayt 3 · Talep"
        accent="#111827"
        baslik="Eylül 2026 için talebimiz: ₺495.000"
        spot="Ağustos'a göre +₺45.608 (+%10,1). Artışın tamamı 1-15 Eylül kırtasiye penceresinde harcanır; 16-30 Eylül Ağustos günlük temposuna döner. Yani bu kalıcı bir bütçe artışı değil, iki haftalık bir sezon hamlesi."
        dipnot="Ciro projeksiyonu son 5 ayın gerçekleşen harcama→ciro aralığı (3,04× – 3,94×) içinden temkinli üst sınır 3,0× – 3,3× alınarak kuruldu. Ağustos'un 3,04×'i taban kabul edildi; Temmuz'un 3,94×'i projeksiyona YAZILMADI."
      >
        <MetrikSira kolon={4}>
          <Metrik etiket="Ağustos gerçekleşen" deger={tl(449392)} alt="Meta ₺269.121 + Google ₺180.271" />
          <Metrik etiket="Eylül talebi" deger={tl(495000)} alt="+₺45.608 · +%10,1" ton="iyi" />
          <Metrik etiket="Beklenen ciro" deger="₺1,49 – 1,63 M" alt="harcama → ciro 3,0× – 3,3×" ton="iyi" />
          <Metrik etiket="Artışın harcanacağı pencere" deger="1 – 15 Eylül" alt="ikinci yarı Ağustos temposu" />
        </MetrikSira>

        <div>
          <div className="text-[11px] font-semibold text-gray-700 mb-2.5">Mecra dağılımı</div>
          <Dagilim
            toplam={495000}
            kalemler={[
              { ad: 'Meta Ads', tutar: 290000, renk: '#0F766E', not: 'katalog + kırtasiye koleksiyonu' },
              { ad: 'Google Ads', tutar: 205000, renk: '#1D4ED8', not: 'PMax + Arama, kırtasiye ağırlıklı' },
            ]}
          />
        </div>

        <Tablo
          baslik="Ağustos gerçekleşen → Eylül plan"
          basliklar={['Mecra', 'Ağustos', 'Eylül planı', 'Değişim', 'Eylül\'de ne değişiyor']}
          saga={[1, 2, 3]}
          sarmala={[4]}
          satirlar={[
            ['Meta Ads', '₺269.121', { v: '₺290.000', kalin: true }, { v: '+%8', ton: 'iyi' }, 'Katalog kurgusu kırtasiye koleksiyonuna öncelik verir; oyuncak kreatifleri ikinci yarıda geri gelir.'],
            ['Google Ads', '₺180.271', { v: '₺205.000', kalin: true }, { v: '+%14', ton: 'iyi' }, 'Artışın büyük kısmı burada: Eylül sıçraması arama tarafında yaşanıyor.'],
            [{ v: 'Toplam' }, '₺449.392', { v: '₺495.000' }, { v: '+%10', ton: 'iyi' }, ''],
          ]}
          vurguSonSatir
        />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
          <Not tip="bilgi" baslik="Ay ortası karar noktası">
            15 Eylül'de harcama→ciro oranı ölçülür. <strong>3,0×'in altındaysa</strong> ayın ikinci yarısı
            ₺200.000'e çekilir ve ay ₺445.000 civarında kapanır — yani artış talebi, tutmadığı takdirde
            kendi kendini geri alan bir yapıda. <strong>3,3×'in üstündeyse</strong> ikinci yarıda oyuncak
            kreatifleri erken devreye alınır.
          </Not>
          <Not tip="uyari" baslik="Bu sayfadaki Ağustos verisi tam ay değil">
            Rakamlar <strong>31 Ağustos 14:29</strong> itibarıyla çekildi; ayın son yarım günü dahil değil.
            Ay kapandığında Ağustos harcaması bir miktar yukarı gider, dolayısıyla gerçek artış oranı
            %10,1'in bir tık altında kalacaktır.
          </Not>
        </div>

        <GrupSeridi vurgu="HUPALUPA Store" />
      </Slayt>
    </Deck>
  );
}
